import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const getEventNameError = newValue => {
  if (!newValue) {
    return 'MISSING';
  }
  if (newValue.length >= 255) {
    return 'TOO_MANY_CHARACTERS';
  }
  return null;
};
export const getEventNameErrorCopy = nameError => {
  switch (nameError) {
    case 'MISSING':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.nameEvent.missingNameError"
      });
    case 'TOO_MANY_CHARACTERS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.nameEvent.tooManyCharactersError"
      });
    default:
      return null;
  }
};